let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k0Fly")).then(() => parcelRequire('4NPdN'));